import classNames from 'classnames';

import Button from '~components/Button/Button';
import { redirectToEhmp } from '~globals/common';
import { fireTrackEvent } from '~globals/tracking';
import { useAppSelector } from '~hooks/useRedux';
import Star from '~images/inline/star.inline.svg';

type Props = {
    heading?: string;
    description?: string;
    backgroundsurface?: SupportedBackgroundColor;
};

const IepInfographic = ({
    heading = 'When to Enroll in Medicare for the First Time',
    description = 'Your Initial Enrollment Period (IEP) is when you can first enroll in Medicare. This includes the 3 months before your 65th birthday, your birthday month, and the 3 months after.',
    backgroundsurface = 'bg-surface-100',
}: Props) => {
    const allid = useAppSelector((state) => state.global.allianceId);
    const countyName = useAppSelector((state) => state.global.geoLocation.countyName);
    const leadToken = useAppSelector((state) => state.global.leadToken);
    const ntmVisited = useAppSelector((state) => state.global.ntmVisited);
    const sessionCode = useAppSelector((state) => state.user.savedSession.sessionCode);
    const trackingParams = useAppSelector((state) => state.global.trackingParams);
    const zip = useAppSelector((state) => state.global.geoLocation.zip);

    const handleShoppingRedirect = () => {
        fireTrackEvent({ page: { action: `IEP Infographic: Compare Plans` } });
        redirectToEhmp({
            ...trackingParams,
            allid: allid,
            zip: zip,
            leadToken: leadToken,
            county: countyName,
            action: 'redirect_with_zip_code',
            lastV1Action: 'quoteFromV1',
            ...(ntmVisited.length > 0 && { n2m: 'true' }),
            ...(sessionCode && { ppSaveSessionId: sessionCode }),
        });
    };

    return (
        <section className={classNames('px-4 py-10 md:py-16', backgroundsurface)}>
            <div className="max-w-1200 mx-auto font-poppins">
                <h2 className="text-32 leading-40 font-poppins font-bold text-link-visited text-center md:text-40 md:leading-56 lg:text-left lg:text-48 lg:leading-62">
                    {heading}
                </h2>
                <div className="grid grid-cols-5 gap-6 mt-10">
                    <div className="text-18 col-span-full md:col-span-3 text-center md:text-left">
                        {description}
                    </div>
                    <div className="hidden md:block col-span-2">
                        <Button
                            styletype="primary"
                            className="w-full lg:w-64 lg:ml-auto"
                            onClick={() => handleShoppingRedirect()}
                        >
                            Compare Plans
                        </Button>
                    </div>
                </div>
                <p className="text-18 leading-28 text-[#103110] font-poppins font-bold my-8 text-center xl:text-left">
                    Example: Turning 65 on September 4th. Your IEP is June 1 - December 30
                </p>
                <div className="hidden md:flex justify-center items-center ml-[104px]">
                    <Star />
                    <span className="text-primary text-18 leding-28 font-bold ml-2">
                        Turning 65
                    </span>
                </div>
                <div className="hidden md:grid grid-cols-7 gap-[1px] mt-4">
                    <div className="flex justify-center bg-surface-primary text-white text-18 leading-28 font-bold py-2">
                        1
                    </div>
                    <div className="flex justify-center bg-surface-primary text-white text-18 leading-28 font-bold py-2">
                        2
                    </div>
                    <div className="flex justify-center bg-surface-primary text-white text-18 leading-28 font-bold py-2">
                        3
                    </div>
                    <div className="flex justify-center bg-surface-primary text-white text-18 leading-28 font-bold py-2">
                        4
                    </div>
                    <div className="flex justify-center bg-surface-primary text-white text-18 leading-28 font-bold py-2">
                        5
                    </div>
                    <div className="flex justify-center bg-surface-primary text-white text-18 leading-28 font-bold py-2">
                        6
                    </div>
                    <div className="flex justify-center bg-surface-primary text-white text-18 leading-28 font-bold py-2">
                        7
                    </div>
                </div>
                <div className="grid grid-cols-6 md:grid-cols-7 mt-8">
                    <div className="col-span-2 md:col-span-2 xl:col-span-3 flex text-center justify-center bg-surface-highlight text-white text-18 leading-28 p-2 rounded-l-full">
                        3 months before
                    </div>
                    <div className="col-span-2 md:col-span-3 xl:col-span-1 flex text-center justify-center bg-comms text-white text-20 leading-28 font-bold p-2">
                        65th Birthday
                    </div>
                    <div className="col-span-2 md:col-span-2 xl:col-span-3 flex text-center justify-center bg-surface-highlight text-white text-18 leading-28 p-2 rounded-r-full">
                        3 months after
                    </div>
                </div>
                <div className="md:hidden mt-10">
                    <Button
                        styletype="primary"
                        className="w-full lg:w-64 lg:ml-auto"
                        onClick={() => handleShoppingRedirect()}
                    >
                        Compare Plans
                    </Button>
                </div>
            </div>
        </section>
    );
};

export default IepInfographic;
